// extracted by mini-css-extract-plugin
module.exports = {"container_activity":"activity_container_activity__CeNVf","date":"activity_date__1qCNV","label":"activity_label__UGvyN"};